import ContractRangeRoleParameter from '@/domain/contract/entity/contract-range-role-parameter.entity';
import ContractRangeParameter from '@/domain/contract/entity/contract-range-parameter.entity';
import FilterUtils from '@/shared/utils/filters';
import MetaData from './metadata.entity';

export default class ItemScriptBase {
  type: string;

  value: any;

  rangeLength: number = 1;

  constructor(object: any = {}) {
    this.type = object.type;
    this.value = object.value;
    this.rangeLength = object.rangeLength || (this.isSeniority ? 1 : 2);
  }

  get isMoneyInput(): boolean {
    return this.type === 'MONEY';
  }

  get isMoney2Input(): boolean {
    return this.type === 'MONEY2';
  }

  get isPercentInput(): boolean {
    return this.type === 'PERCENT';
  }

  get isPercent2Input(): boolean {
    return this.type === 'PERCENT2';
  }

  get isLongInput(): boolean {
    return this.type === 'LONG';
  }

  get isRangeInput(): boolean {
    return this.type === 'RANGE';
  }

  get isRange2Input(): boolean {
    return this.type === 'RANGE2';
  }

  get isStringListInput(): boolean {
    return this.type === 'STRING_LIST';
  }

  get isKeyValueInput(): boolean {
    return this.type === 'KEY_VALUE';
  }

  get isRangePercentInput(): boolean {
    return this.type === 'RANGE_PERCENT';
  }

  get isRangePercent2Input(): boolean {
    return this.type === 'RANGE_PERCENT2';
  }

  get isKeyValuePercentInput(): boolean {
    return this.type === 'KEY_VALUE_PERCENT';
  }

  get isBooleanInput(): boolean {
    return this.type === 'BOOLEAN';
  }

  get isCurrency(): boolean {
    return this.type === 'CURRENCY_CONVERT';
  }

  get isSeniority(): boolean {
    return this.type === 'STRING_LIST_SENIORITY';
  }

  get isValid() {
    return (this.isMoneyInput || this.isMoney2Input) && parseFloat(this.value) > 0.0;
  }

  get valueSize() {
    if (this.value) {
      return Number(this.value.length || 0);
    }
    return 0;
  }

  isLastValue(index: number): boolean {
    return this.value.length === index + 1;
  }

  initialQuantity(index: number): any {
    if (index === 0) {
      return 1;
    }
    let previousQuantity = parseInt(this.value[index - 1].quantidade, 10);
    return previousQuantity += 1
  }

  finalQuantityType(index: number): string {
    return this.isLastValue(index) ? 'text' : 'number';
  }

  faixaName(index: number): string {
    const normalizedIndex: number = index + 1;
    if (normalizedIndex === 1) {
      return 'Faixa 1 - Inicial';
    }
    if (normalizedIndex === this.value.length) {
      return `Faixa ${normalizedIndex} - Final`;
    }
    return `Faixa ${normalizedIndex}`;
  }

  get genericRange(): any {
    return {
      quantidade: 0,
      valor: 0.00,
    }
  }

  get genericLastRange(): any {
    return {
      quantidade: 'Infinito',
      valor: 0.00,
    }
  }

  addStringValue(value: string) {
    if (value) {
      this.value.push(value)
    }
  }

  addCurrencyConvertValue(value: string) {
    this.value[0] = value;
  }

  handleKeyValueParameter(value: any) {
    const keys = Object.keys(value);
    return keys.map((el: any) => MetaData.of(
      { field: el, value: parseFloat(value[el].toString()).toFixed(2) },
    ))
  }

  validateMoneyFormatValues() {
    if ((this.isRangeInput || this.isRange2Input)) {
      this.value.forEach((el: ContractRangeParameter, index: number) => {
        el.valor = FilterUtils.formatValue(el.valor);
      })
    }
    if ((this.isMoneyInput || this.isMoney2Input) || this.isPercentInput || this.isPercent2Input) {
      this.value = FilterUtils.formatValue(this.value);
    }
  }

  /**
   * Function to add parameter ranges roles and seniorities
   * @param numberOfRanges
   */
  addGenericRangeRoles(numberOfRanges: number) {
    this.value = [];
    const times: number = numberOfRanges;

    for (let i: number = 0; i < times; i += 1) {
      this.value.push(new ContractRangeRoleParameter([]));
    }
  }

  updateValueRoleArray(): void {
    if (this.rangeLength > this.value.length) {
      const times: number = this.rangeLength - this.value.length;
      for (let i: number = 0; i < times; i += 1) {
        this.value.push(new ContractRangeRoleParameter([]));
      }
    }

    if (this.rangeLength < this.value.length) {
      const times: number = this.value.length - this.rangeLength;
      for (let i: number = 0; i < times; i += 1) {
        if (this.rangeLength > 0) {
          this.value.pop();
        }
      }
    }
  }
}
